import { action } from 'mobx';
import { objectMapper } from '../../utils/helpers/objectHelpers';

export interface IFormModel {
  OnModelChange: <T extends keyof FormModel>(key: T, value: any) => void;
  SetData: (dbData: any) => void;
}

abstract class FormModel implements IFormModel {
  @action
  public OnModelChange = <T extends keyof FormModel>(key: T, value: any) => {
    this[key] = value;
  };

  @action
  public SetData(dbData: any, ignoreProps: Array<string> = []): void {
    objectMapper(dbData, this, ignoreProps);
  }
}

export default FormModel;
